import Lib from '../../../commons/lib';

export default class Service {
  static musorUrl = window.location.origin + '/api/musor/';
  static helyszinUrl = window.location.origin + '/api/helyszin/';
  static eloadasUrl = window.location.origin + '/api/eloadas/';
  static jegyUrl = window.location.origin + '/api/jegy/';
  static teremberlesUrl = window.location.origin + '/api/teremberles/';
  static partnerUrl = window.location.origin + '/api/partner/';
  static penzugykozosUrl = window.location.origin + '/api/penzugykozos/';

  // MŰSOR START

  static listMusor(listParam, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'musor/list',
      params: listParam,
    }], fnDone);
  }

  static listMusorGroupByNapok(listParam, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'musor/list/bynapok',
      params: listParam,
    }], fnDone);
  }

  static getMusor(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'musor',
      params: { id: id }
    }], fnDone);
  }

  static addMusor(musor, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.musorUrl + 'musor',
      data: musor
    }], fnDone);
  }

  static editMusor(musor, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'musor',
      data: musor,
      params: { id: musor.id }
    }], fnDone);
  }

  static editMusorAlkalmak(musor, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'musor/alkalmak',
      data: musor,
      params: { id: musor.id }
    }], fnDone);
  }

  static deleteMusor(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.musorUrl + 'musor',
      params: { id: id }
    }], fnDone);
  }

  static saveSelectedJegyek(musorId, jegyek, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'musor/jegyek',
      params: { id: musorId }, 
      data: jegyek,
    }], fnDone);
  }

  static listEsemenyTipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'musor/enum/esemenytipus',
    }], fnDone);
  }

  static getRendelesParams() {
    return new Promise((resolve, reject)=> {
      Lib.MicroServices.requestService([{
        method: 'GET',
        url: Service.musorUrl + 'musor/rendelesparams'
      }], (error, result)=> {
        if (!error) {
          resolve(result[0]);
        } else {
          reject(error);
        }
      });
    });
  }


  static jegySWExists(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'musor/jegyswexists'
    }], fnDone);
  }

  // MŰSOR END

  // TULAJDONSÁG START

  static listTulajdonsag(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'tulajdonsag/list',
    }], fnDone);
  }

  static getTulajdonsag(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'tulajdonsag',
      params: { id: id }
    }], fnDone);
  }

  static addTulajdonsag(tulajdonsag, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.musorUrl + 'tulajdonsag',
      data: tulajdonsag
    }], fnDone);
  }

  static editTulajdonsag(tulajdonsag, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'tulajdonsag',
      data: tulajdonsag,
      params: { id: tulajdonsag.id }
    }], fnDone);
  }

  static deleteTulajdonsag(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.musorUrl + 'tulajdonsag',
      params: { id: id }
    }], fnDone);
  }

  static getAngolNyelv(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'tulajdonsag/angolnyelv',
    }], fnDone);
  }

  // TULAJDONSÁG END

  // ALKALOM START

  static getAlkalom(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'alkalom',
      params: { id: id }
    }], fnDone);
  }

  static editAlkalom(alkalom, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'alkalom',
      data: alkalom,
      params: { id: alkalom.id }
    }], fnDone);
  }

  static deleteAlkalom(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.musorUrl + 'alkalom',
      params: { id: id }
    }], fnDone);
  }

  static atadasAlkalmak(alkalmak, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'alkalom/atadas',
      data: alkalmak,
    }], fnDone);
  }

  // ALKALOM END

  // JEGYÁRAK START

  static addJegyAr(jegyAr, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.musorUrl + 'jegyar',
      data: jegyAr,
    }], fnDone);
  }

  static getJegyAr(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'jegyar',
      params: { id: id }
    }], fnDone);
  }

  static editJegyAr(jegyAr, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'jegyar',
      data: jegyAr,
      params: { id: jegyAr.id }
    }], fnDone);
  }

  static deleteJegyAr(jegyArId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.musorUrl + 'jegyar',
      params: { id: jegyArId}
    }], fnDone);
  }

  // JEGYÁRAK END

  // ELőADÁS START

  static listEloadasok(param, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.eloadasUrl + 'eloadas/list/base',
      params: { param: param },
    }], fnDone);
  }

  static getEloadasIdotartam(id, fnDone) {
    return new Promise((resolve, reject)=> {
      Lib.MicroServices.requestService([{
        method: 'GET',
        url: Service.eloadasUrl + 'eloadas/idotartam',
        params: { id: id },
      }], (error, result)=> {
        if (!error) {
          resolve(result[0]);
        } else {
          reject(error);
        }
      });
    });
  }

  // ELŐADÁS END

  
  // HELYSZÍN START
  
  static listHelyszinSelect(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/list/select',
      params: { tipus: "SAJAT"},
    }], fnDone);
  }

  static listTeremSelect(helyszinId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem/list/select',
      params: { id: helyszinId },
    }], fnDone);
  }

  static listTeremkiosztas(helyszin, teremkiosztasKod, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem/kiosztas/list',
      params: { helyszinIds: [helyszin], teremkiosztasallapot: "AKTIV", kod: teremkiosztasKod },
    }], fnDone);
  }

  // HELYSZÍN END

  // JEGY START
  
  static listJegyek(param, penznemId, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.jegyUrl + 'jegy/list',
      params: { param, penznemId },
    }], fnDone);
  }

  static listJegyArKategoriak(teremkiosztas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.jegyUrl + 'jegy/listarkategoria',
      params: { teremkiosztas: teremkiosztas },
    }], fnDone);
  }

  // JEGY END

  // KÉNYELMI DÍJ START

  static listKenyelmiDij(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'kenyelmidij/list',
    }], fnDone);
  }

  static initKenyelmiDijForm(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'kenyelmidij/init',
      params: { id },
    }], fnDone);
  }

  static insertKenyelmiDij(kenyelmidij, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.musorUrl + 'kenyelmidij',
      data: kenyelmidij
    }], fnDone);
  }

  static modifyKenyelmiDij(kenyelmidij, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.musorUrl + 'kenyelmidij',
      data: kenyelmidij,
    }], fnDone);
  }

  static deleteKenyelmiDij(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.musorUrl + 'kenyelmidij',
      params: { id: id }
    }], fnDone);
  }

  static getKenyelmiDijByHelyszinId(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'kenyelmidij',
      params: { id },
    }], fnDone);
  }

  static getKenyelmiDijParam(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.musorUrl + 'kenyelmidij/param',
    }], fnDone);
  }
  
  // KÉNYELMI DÍJ END

  // PÉNZNEM START

  static listAktivPenznem(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugykozosUrl + 'penznem/aktiv',
    }], fnDone);
  }

  static getDefaultPenznem(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.penzugykozosUrl + 'penznem/defaultcurrency',
    }], fnDone);
  }

  // PÉNZNEM END

}